import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "./context/AuthProvider";
import { CountryProvider } from "./context/CountryProvider";
import theme from './theme';
import { ThemeProvider } from "@mui/material/styles";
import { CssBaseline } from "@mui/material";
import { Provider } from "react-redux";
import {store} from "./store/store"

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <div id="MainDiv">
    {/* <React.StrictMode> */}
      <Provider store={store}>
      <BrowserRouter> 
         <AuthProvider>
          <CountryProvider>
            <ThemeProvider theme={theme}>
              {/* <CssBaseline /> */}
              <App />
            </ThemeProvider>
           </CountryProvider>
        </AuthProvider> 
      </BrowserRouter>
      </Provider>
    {/* </React.StrictMode> */}

    <footer style={{ display: "flex", justifyContent: "center" }}>
      © IQVIA All rights reserved.
    </footer>
  </div>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
